export const otherCertificateNumberMessage = '其它证件号码长度应为8～18位';

export function isOtherCertificateType(type) {
  return ['99', '其它', '其他'].includes(String(type));
}

export function isOtherCertificateNumberValid(type, value) {
  const length = value == null ? 0 : String(value).length;
  return !isOtherCertificateType(type) || (length >= 8 && length <= 18);
}

export function otherCertificateNumberRule(item, list, getForm) {
  const typeFields = { insCredentials: 'insCredentialsType', certificateContent: 'certificateType' };
  const typeFieldName = typeFields[item.fieldName];
  const typeField = typeFieldName && list.find(field => field.fieldName === typeFieldName);
  if (!typeField) return null;
  return {
    trigger: 'onBlur',
    message: otherCertificateNumberMessage,
    validator(value) {
      return isOtherCertificateNumberValid(getForm()[String(typeField.id)], value);
    },
  };
}
